import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';

export const formatDate = (date, locale = ptBR) => {
  if (!date) return '';
  return format(new Date(date), "dd/MM/yyyy 'às' HH:mm", {
    locale: locale,
  });
};

export const formatDateOnly = (date, locale = ptBR) => {
  if (!date) return '';
  return formatInTimeZone(new Date(date), 'UTC', 'dd/MM/yyyy', {
    locale,
  });
};
